/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import "../../../assets/styles/custom-style.css";
import "../../../assets/styles/custom-style.scss";
import { useAuth } from "../../../auth";



const Support = () => {
  const { currentUser } = useAuth();
  return (
    <>
      <section className="container-fluid">
        <div className="row">

          <section className="content-section">
            {/* <!-- Main Content Section Starts here --> */}
            <section className="row main-content settlement-content settings-content">
              <div className="title mb-3 d-flex align-items-center">
                <h3 className="mb-0 me-2">Support</h3>
                <p className="mb-0 opacity-150 mt-2"></p>
              </div>
              <div className="title mb-12 md-3 mt-3">
                <h5 className="mb-1 mid-gray fw-bold">
                  <small>Hello, Chef {currentUser?.data?.name}!</small>
                </h5>
              </div>
              <h6 className="mb-3 mt-3">
                <small className="mt-1">
                  Thank you for reaching out to Frayo. For additional
                  assistance,
                </small>
              </h6>
              <h6 className="mb-3">
                <small className="mt-1">
                  Please contact{" "}
                  <a
                    className="link cursorPointer"
                    href="mailto:support@frayo.net"
                  >
                    <b>support@frayo.net</b>
                  </a>
                </small>
              </h6>
            </section>
            {/* <!-- Main Content Section Ends here --> */}
          </section>

        </div>
      </section>
    </>
  );
};

export default Support;
